import React, { useEffect } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as verificationActions from 'actions/verificationActions';

import VerificationPending from 'components/verification/VerificationPending';

const VerificationPendingContainer = ({verifyUser, verificationToken}) => {
  useEffect(() => {
    verifyUser(verificationToken);
  }, []);

  return <VerificationPending />;
};

VerificationPendingContainer.propTypes = {
  verificationToken: propTypes.string.isRequired,
  verifyUser: propTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    verificationToken: state.verification.verificationToken
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({verifyUser: verificationActions.verifyUser}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(VerificationPendingContainer);
